<template>
  <component :is="layout">
    <router-view />
  </component>
  <div v-if="isLoading" class="loading-spinner d-flex justify-content-center align-items-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <MainFooter/>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LoginLayout from './layouts/LoginLayout.vue';
import MainLayoutMunicipality from './layouts/MainLayoutMunicipality.vue';
import MainFrontLayout from './layouts/MainFrontLayout.vue';
import RegisterLayout from './layouts/RegisterLayout.vue';
import loadingStore from './loading'; 
import MainFooter from './layouts/MainFooter.vue';

export default {
  
  name: 'App',
  components: {
    LoginLayout,
    MainLayoutMunicipality,
    RegisterLayout,
    MainFrontLayout,
    MainFooter
  },
  setup() {
    const isLoading = computed(() => loadingStore.isLoading.value);
    const route = useRoute();
    const layout = computed(() => route.meta.layout || 'MainFrontLayout');
    onMounted(() => {
      document.title = "Πλατφόρμα Ticketing";
    });
    return { layout, isLoading };
  }
};
</script>

<style>
  @font-face {
    font-family: 'cera';
    src: url('@/assets/fonts/cera/cera.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'cera';
    src: url('@/assets/fonts/cera/cera-medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'cera';
    src: url('@/assets/fonts/cera/cera-bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'cera';
    src: url('@/assets/fonts/cera/cera-black.otf') format('opentype');
    font-weight: 900;
    font-style: normal;
  }


  * {
    font-family: 'cera', sans-serif;
    font-weight: normal;
  }
  
  .loading-spinner {
    position: fixed;
    top: 12%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    margin-top: 200px; /* Adjust this value to move the spinner down */
  }

  .spinner-border {
    width: 3rem;
    height: 3rem;
  }
</style>
